import { showError } from '../../../elements/Toasts/toastActions';
import { logout } from '../../../components/auth/redux/authActions';
import strings from '../../../lang/lang';

export default function handleError({ data, status }) {
  switch (status) {
    case 401:
      logout();
      break;
    case 409:
      showError(strings.appWebhooks.errors.urlUsedException);
      break;
    case 400:
      if (data.message === 'Webhook url is taken by another partner') {
        showError(strings.appWebhooks.errors.urlUsedException);
      } else {
        showError(data.message);
      }
      break;
    default:
      showError(strings.appWebhookDetails.errors.updatingException);
      break;
  }
}
